// extracted by mini-css-extract-plugin
export default {"divStyles":"Favorites_divStyles__cKsix"};